import styled from 'styled-components';

export const StyledDashedButton = styled.button<{ disabled?: boolean; $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 44px;
  padding: 8px 16px;
  border: 1px dashed ${(props) => props.theme.color.ink_black};
  border-radius: 4px;
  background-color: ${(props) => (props.$isActive ? props.theme.color.off_white : props.theme.color.grey95)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s ease;
  font-size: ${(props) => props.theme.font.text.size}px;
  font-weight: ${(props) => props.theme.font.text.weight};
  line-height: ${(props) => props.theme.font.text.lineHeight}px;
  color: ${(props) => props.theme.color.ink_black};

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.color.grey85};
    border-color: ${(props) => props.theme.color.brand};
  }

  &:active:not(:disabled) {
    background-color: ${(props) => props.theme.color.grey75};
  }

  &:disabled {
    border-color: ${(props) => props.theme.color.grey75};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.color.brand};
    outline-offset: 2px;
  }
`;
